import React, { useEffect, useRef, useState } from "react";
import "./promo-code.scss";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import CusForm from "../../mui/CusForm";
import CusInput from "../../mui/custom_input/CusInput";
import { API_USER } from "../../../api/user";
import { DEBUG, TEST_MODE } from "../../../store/enums";
import { useSelector } from "react-redux";
import PromoCodeSuccess from "./PromoCodeSuccess";
import { dispatchCusEvent } from "../../../utils/utils";
import imgPercent from "./percent-banner.png";
import SuccessCancelButtons from "../../mui/success_cancel_buttons/SuccessCancelButtons";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener";
import CusCaptcha from "../../CusCaptcha";
import useRequireVerify from "../../../hooks/useRequireVerify";

export default function PromoCodeModal({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const currency = useSelector((state) => state.user.currency);
  const { lockPromocode } = useRequireVerify();

  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [successData, setSuccessData] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const captchaRef = useRef();

  const onSubmit = async (_, field) => {
    const data = {
      promocode: field.promocode,
      currency,
      captcha: captchaRef.current?.getValue?.()
    };
    if (TEST_MODE) return setSuccessData({ amount: 4, currency });

    await API_USER.promocode(data)
      .then((e) => {
        if (DEBUG) console.log("promocode res", e);
        const data = e.data;
        if (data?.dataError || data?.error) {
          captchaRef.current?.reset?.();
          return;
        }

        setSuccessData({ amount: data.amount, currency: data.currency });
        dispatchCusEvent(ENUM_COMMON_EVENT.getBalance);
      })
      .catch((e) => {
        if (DEBUG) console.log("promocode catch", e);
        captchaRef.current?.reset?.();
      });

    setError("");
  };

  useEffect(() => {
    if (isOpen) {
      if (lockPromocode) {
        dispatchCusEvent(ENUM_COMMON_EVENT.emailNotConfirmed);
        closeModal();
        return;
      }
      return;
    }
    setSuccessData(false);
    setCode("");
    captchaRef.current?.reset();
  }, [isOpen]);

  const transparentClass = successData ? "" : "transparent";

  return (
    <DefaultModal
      miniModal
      isOpen={isOpen}
      closeModal={closeModal}
      classModal={`promo-code ${transparentClass}`}>
      {successData ? (
        <PromoCodeSuccess info={successData} />
      ) : (
        <div className="promo-code__content">
          <div className="promo-code__img">
            <img src={imgPercent} />
          </div>

          <div className="promo-code__info">
            {/* <CloseModal close={closeModal} /> */}
            <h2>{t("Promotional code")}</h2>
            <p className="promo-code__text">
              {t(
                "Enter the promotional code and the deposit will be instantly credited to your balance"
              )}
            </p>
            <CusForm
              onSubmit={async (e, f) => {
                setBtnLoading(true);
                await onSubmit(e, f);
                setBtnLoading(false);
              }}>
              <CusInput
                name={"promocode"}
                placeholder={"Promotional code"}
                required
                defaultValue={code}
                onChange={(e) => setCode(e.target.value)}
                errorWarning={error}
              />

              <CusCaptcha captchaRef={captchaRef} />

              <SuccessCancelButtons
                btnLoading={btnLoading}
                setBtnLoading={setBtnLoading}
                closeModal={closeModal}
              />
            </CusForm>
          </div>
        </div>
      )}
    </DefaultModal>
  );
}
